module.exports = __webpack_public_path__ + "img/2.2eaa1f28.jpg";